import { memo } from "react";
import { driverTabs } from "../../../consts/tabs";

import { SectionMenu } from "../components/SectionMenu";
import DriverDetail from "../../DriverDetail";

export const DriverManagementSections = memo(() => {
  return (
    <SectionMenu tabs={driverTabs}>
      <SectionMenu.SectionMenuItem id={0}>
        <DriverDetail />
      </SectionMenu.SectionMenuItem>
      <SectionMenu.SectionMenuItem id={1}>
        <DriverDetail showWorkSchedule />
      </SectionMenu.SectionMenuItem>
    </SectionMenu>
  );
});
